import axios, { AxiosRequestConfig } from "axios";
import store from "@/store";

export abstract class Api {
	protected readonly baseUrl: string = window.location.origin + "/api/";
	private plainToken: any;

	public get Token() { return store.state.token; }

	protected constructor() {

	}

	protected get BaseUrl() {
		return this.baseUrl;
	}

	protected get Config(): AxiosRequestConfig {
		return {
			headers: {
				Authorization: `Bearer ${this.Token}`,
			},
		};
	}

	protected async executeWithErrorHandling<T>(f: () => Promise<T>): Promise<T> {
		try {
			return await f();
		} catch (error) {
			if (axios.isAxiosError(error)) {
				if (error.response && error.response.status === 401) {
					store.commit("setToken", undefined);
					// console.log(error);

					throw new Error("Not Authorized");
				} else
					throw error;
			} else
				throw error;
		}
	}


}
